export default {"src":"/_next/static/media/youtube-video.23498a09.svg","height":16,"width":20};